import { Reducer } from 'react';
import { IActionPayload } from 'types';
import { DatabaseDetailState } from './state';

const reducer: Reducer<DatabaseDetailState, IActionPayload> = (
  state,
  action,
): DatabaseDetailState => {
  switch (action.type) {
    case 'GET_DATABASE':
    case 'UPDATE_VALUE':
    case 'UPDATE_FIELD':
    case 'PATCH_DATABASE':
      return {
        ...state,
        database: action.payload,
      };

    case 'SET_LOADING': {
      return {
        ...state,
        updateLoading: action.payload,
      };
    }

    case 'SET_ERRORS': {
      return {
        ...state,
        errors: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default reducer;
